import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';
import Link from 'valuelink';
import {
  Button,
  Col,
  DatePicker,
  Icon,
  Input as AntInput,
  Modal,
  Row,
  Select,
  Spin,
  Switch,
  message,
  Typography,
} from 'antd';
import { Input } from 'valuelink/lib/tags';
import { SemiboldText, ButtonText } from '../../components/common/Text';
import {
  uploadProfilePicture,
  updateNetworkCenterSettlements,
} from '../../services';
import { fetchCenterBasicProfile } from '../../services';

const { Option } = Select;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 14px;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

class NetworkCenterSettlement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      saved: false,
      successSaved: false,
      errorMessage: '',
      payeeName: '',
      accountNumber: '',
      accountType: '',
      ifscCode: '',
      visitCommission: 0,
      visitCommissionOperation: 'percentage',
      visitCommissionStartDate: null,
    };
    console.log({ props });

    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    if (this.centerId) {
      this.fetchProfile();
    }
  };

  fetchProfile = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.centerId)
      .then((res) => {
        const basicProfile = res;
        const { settlementDetails } = basicProfile;
        if (settlementDetails) {
          this.setState({
            payeeName: settlementDetails.name || '',
            accountNumber: settlementDetails.bankAccount || '',
            accountType: settlementDetails.accountType || '',
            ifscCode: settlementDetails.ifsc || '',
            visitCommission: settlementDetails.visitCommission || '',
            visitCommissionOperation:
              settlementDetails.visitCommissionOperation || '',
            visitCommissionStartDate: moment(
              settlementDetails.visitCommissionStartDate
            ).isValid()
              ? moment(settlementDetails.visitCommissionStartDate)
              : null,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: 16,
      color: '#514f54',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    valueContainer: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    input: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
  };

  handleAttachment = () => {
    const { authToken } = this.props;
    const file = document.querySelector('#imageAttachment').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      document.querySelector('#imageAttachment').value = null;
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadProfilePicture(file, this.doctorId, onUploadProgress, authToken)
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
          });
          this.fetchProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  valueOrUndefined = (value) => {
    return value.trim() === '' ? undefined : value;
  };

  submit = () => {
    this.setState({ saving: true });
    const {
      payeeName,
      accountNumber,
      accountType,
      ifscCode,
      visitCommission,
      visitCommissionOperation,
      visitCommissionStartDate,
    } = this.state;
    if (payeeName === '') {
      return message.error('Kindly fill mandatory fields Payee Name', 3);
    }
    // setTimeout(() => {
    //   const amhiSavingTo = {
    //     status: 1,
    //   };
    //   this.setState({ amhi: amhiSavingTo });
    // }, 2000);
    // setTimeout(() => {
    //   const amhiSavingTo = {
    //     status: -1,
    //     errorMessage: 'Something went wrong',
    //   };
    //   this.setState({ acko: amhiSavingTo });
    // }, 3000);
    // setTimeout(() => {
    //   const ackocopaySavingTo = {
    //     status: 1,
    //   };
    //   this.setState({ ackocopay: ackocopaySavingTo });
    // }, 3000);
    const fulfilmentDetails = {
      payeeName: payeeName,
      accountNumber: this.valueOrUndefined(accountNumber),
      accountType: this.valueOrUndefined(accountType),
      ifsc: this.valueOrUndefined(ifscCode),
      visitCommission,
      visitCommissionOperation,
      visitCommissionStartDate: visitCommissionStartDate
        ? visitCommissionStartDate.format('YYYY-MM-DD')
        : null,
    };
    // this.setState({ loading: true });
    updateNetworkCenterSettlements(this.centerId, fulfilmentDetails)
      .then((res) => {
        if (res.message === 'success') {
          this.setState({
            successSaved: true,
          });
          setTimeout(() => {
            this.closeSavingModal();
          }, 3000);
        } else {
          this.setState({
            errorMessage:
              res.errorMessage ||
              'Something went wrong. Please try again later',
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          errorMessage:
            err.errorMessage || 'Something went wrong. Please try again later',
        });
      })
      .finally(() => {
        this.setState({
          saved: true,
        });
      });
  };

  closeSavingModal = () => {
    this.setState({
      saving: false,
      successSaved: false,
      saved: false,
      errorMessage: '',
    });
  };

  setStartDate = (date) => {
    console.log(date);
    this.setState({
      visitCommissionStartDate: date,
    });
  };

  render() {
    const {
      loading,
      saved,
      saving,
      successSaved,
      errorMessage,
      visitCommission,
      visitCommissionOperation,
    } = this.state;
    let showAutoCloseMessage = false;
    if (saved && successSaved) {
      // All saved successfully
      showAutoCloseMessage = true;
    }
    const payeeNameInputLink = Link.state(this, 'payeeName');
    const accountNumberInputLink = Link.state(this, 'accountNumber');
    const accountTypeInputLink = Link.state(this, 'accountType');
    const ifscCodeInputLink = Link.state(this, 'ifscCode');
    const visitCommissionLink = Link.state(this, 'visitCommission');
    const visitCommissionOperationType = (
      <Select
        value={visitCommissionOperation}
        onChange={(e) => this.setState({ visitCommissionOperation: e })}
      >
        <Option value="percentage">Percentage</Option>
        <Option value="fixed">Fixed Value</Option>
      </Select>
    );
    return (
      <Row type="flex" gutter={[16, 16]}>
        <Col span={24}>
          <TitleText>Consultation Settlement</TitleText>
        </Col>
        {loading ? (
          <Spin spinning={loading} />
        ) : (
          <Col xs={{ order: 2, span: 24 }} md={{ order: 1, span: 12 }}>
            <Row gutter={[16, 16]}>
              {/* {this.state.validationErrors.dependentName ? (
              <ValidationText>
                {this.state.validationErrors.dependentName.errorMessage}
              </ValidationText>
            ) : null} */}
              <Col span={12}>
                <LabelText>Payee Name</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={payeeNameInputLink}
                  placeholder="Payee Name"
                />
              </Col>
              <Col span={12}>
                <LabelText>Account Number</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={accountNumberInputLink}
                  placeholder="Account Number"
                />
              </Col>
              <Col span={12}>
                <LabelText>Account Type</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={accountTypeInputLink}
                  placeholder="Account Type"
                />
              </Col>
              <Col span={12}>
                <LabelText>IFSC Code</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={ifscCodeInputLink}
                  placeholder="IFSC Code"
                />
              </Col>
              <Col span={12}>
                <LabelText>Visit Commission</LabelText>
                <AntInput
                  value={visitCommission}
                  addonBefore={visitCommissionOperationType}
                  onChange={(e) => {
                    this.setState({
                      visitCommission: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="Online Discount"
                />
              </Col>
              <Col span={12}>
                <LabelText>Visit Commission Start Date</LabelText>
                <DatePicker
                  onChange={this.setStartDate}
                  placeholder="Choose a date"
                />
              </Col>
              <Col span={24}>
                <Button block type="primary" size="large" onClick={this.submit}>
                  <ButtonText>Submit</ButtonText>
                </Button>
              </Col>
            </Row>
          </Col>
        )}
        <Modal
          visible={saving}
          title="Saving Settlement Details"
          footer={false}
          closable={false}
        >
          <Row gutter={[16, 16]}>
            <Typography.Text style={{ marginLeft: '8px' }}>
              {errorMessage ? (
                `Error saving settlement details - ${errorMessage}`
              ) : successSaved ? (
                <>
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                  />
                  Settlement details saved successfully
                </>
              ) : (
                <>
                  <Spin size="small" />
                  Saving
                </>
              )}
            </Typography.Text>
            {saved && (
              <>
                <Col span={24}>
                  <Button type="primary" onClick={this.closeSavingModal()}>
                    Close
                  </Button>
                </Col>
                {showAutoCloseMessage && (
                  <Col span={24}>
                    <Typography.Text>
                      This window will automatically close in 3 seconds
                    </Typography.Text>
                  </Col>
                )}
              </>
            )}
          </Row>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  visitSpocs: state.info.operators,
});

export default connect(mapStateToProps)(NetworkCenterSettlement);
